import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

import "react-datepicker/dist/react-datepicker.css";

import {
    GuestsInputForm,
    CustomEventPicker,
    CustomTimePicker,
    CustomProductPicker,
    WheelChairPicker,
    ReservationIdInput,
    MailInfoPicker
} from './CustomPickers'

import {ReservationResult, EventDetailsDisplay} from './CustomDisplay'

import {
    validateField,
    parseEvents,
    getAvailableSpace,
    getCurrentOccupation,
    filterParkings,
    sumReservedAndCurrentParkings,
    sendProductsUpdateEmail
} from '../utils'

import {
    FAILED_STATE,
    COMPLETED_STATE,
    PENDING_STATE,
    DELETED_STATE,
    NOT_CHOOSEN_STATE,
    NAME_FIELD,
    NUMBER_FIELD,
    MAIL_FIELD,
    PLATE_FIELD
} from "../constants"

import {
    NO_ROOM_ERROR,
    INVALID_NAME_ERROR,
    INVALID_PHONE_ERROR,
    INVALID_MAIL_ERROR,
    INVALID_PLATE_ERROR,
    CHOOSE_AN_OPTION_TEXT,
    SANITARY_MEASURES_TEXT,
    UPDATE_BUTTON,
    DELETE_RESERVATION_BUTTON
} from '../strings'


class EditReservationForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            events: {},
            selectedEventId: null,
            reservation: {},
            reservationId: "",
            updateState: NOT_CHOOSEN_STATE,
            initialGuestsFound: 0,
            initialSelectedTime: 0,
            initialPlate: "",
            parkings: {},
            errorMessages: {
                personalDataName: false,
                personalDataPhone: false,
                personalDataMail: false,
                personalDataPlate: false,
                guests: [false, false],
                notAvailableSpace: false,
                selectedEventIdNotFound: false
            },
            parkingReservationState: ""
        }
        this.handleReservationChange = this.handleReservationChange.bind(this)
        this.handleClickSearch = this.handleClickSearch.bind(this)
        this.handleEventChange = this.handleEventChange.bind(this)
        this.handlePersonalDataChange = this.handlePersonalDataChange.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleClickUpdate = this.handleClickUpdate.bind(this)
        this.getReservationErrors = this.getReservationErrors.bind(this)
        this.handleClickDelete = this.handleClickDelete.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
        this.handleWheelChairChange = this.handleWheelChairChange.bind(this)
        this.handleMailInfoChange = this.handleMailInfoChange.bind(this)
        this.handleProductSelected = this.handleProductSelected.bind(this)

        this.reserveParking = this.reserveParking.bind(this)
        this.checkForParkingSpace = this.checkForParkingSpace.bind(this)
    }

    handleReservationChange(event){
        const value = event.target.value.replace(" ", "")
        if (value.length > 9){
            return
        }
        this.setState({
            reservationId: value
        })
    }

    handleClickSearch(event){
        const {
            reservationId, selectedEventId, errorMessages
        } = this.state
        if (reservationId.length < 9){
            // Reservation code should have 9 digits exactly
            errorMessages.reservationNotValid = true
            errorMessages.reservationNotFound = false
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        errorMessages.reservationNotValid = false
        if (selectedEventId === null){
            errorMessages.selectedEventIdNotFound = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        errorMessages.selectedEventIdNotFound = false
        const dbUrl = `guests/${selectedEventId}/${reservationId}`
        let ref = Firebase.database().ref(dbUrl)

        ref.once('value', snapshot => {
            var reservation = snapshot.val();
            if (reservation == null){
                errorMessages.reservationNotFound = true
                this.setState({
                    errorMessages: errorMessages
                })
                return
            }
            const guestsFound = reservation.guests.filter(
                el => {return el.name.length > 0}
            )
            const totalGuestsReservation = guestsFound.length + 1
            errorMessages.reservationNotFound = false
            errorMessages.guests = Array(guestsFound.length).fill(false)
            if (!reservation.products){
                reservation.products = []
            }

            Firebase.database().ref("/parkings").on(
                'value', snapshot => {
                    var parkingsRaw = snapshot.val()
                    if (parkingsRaw == null){
                        parkingsRaw = {}
                    }
                    this.setState({
                        parkings: parkingsRaw
                    })
            })

            this.setState({
                reservation: reservation,
                initialGuestsFound: totalGuestsReservation,
                initialSelectedTime: Number(reservation.selectedTime),
                initialPlate: reservation.personalData.plate,
                updateState: PENDING_STATE,
                errorMessages: errorMessages
            })
        })
    }

    handlePersonalDataChange(nameValue, phoneValue, mailValue, plateValue){
        const{reservation, errorMessages} = this.state
        const formattedPhone = phoneValue.replace("-", "").replace(" ", "")

        // Check for plate
        var formattedPlate = plateValue.replace(" ", "")
        const regexAlphaNum = /^[a-zA-Z]{3}$/
        if (regexAlphaNum.test(formattedPlate)){
            // This is an alpha num plate, add - automatically
            formattedPlate += "-"
        }

        errorMessages.personalDataName = nameValue ? !validateField(NAME_FIELD, nameValue) : false
        errorMessages.personalDataPhone = formattedPhone ? !validateField(NUMBER_FIELD, formattedPhone) : false
        errorMessages.personalDataMail = mailValue ? !validateField(MAIL_FIELD, mailValue) : false
        errorMessages.personalDataPlate = plateValue ? !validateField(PLATE_FIELD, formattedPlate) : false

        reservation.personalData = {
            name: nameValue, phone: formattedPhone, mail: mailValue, plate: formattedPlate
        }
        this.setState({
            errorMessages: errorMessages,
            reservation: reservation
        })
    }

    handleInputChange(index, value){
        const {reservation, errorMessages} = this.state
        errorMessages.guests[index] = value ? !validateField(NAME_FIELD, value) : false
        reservation.guests[index].name = value
        errorMessages.notAvailableSpace = false
        this.setState({
            reservation: reservation,
            errorMessages: errorMessages
        })
    }

    getReservationErrors(){
        const {errorMessages, reservation} = this.state
        if (errorMessages.notAvailableSpace){
            return NO_ROOM_ERROR
        }
        if (errorMessages.personalDataName || !reservation.personalData.name){
            return INVALID_NAME_ERROR
        }
        if (errorMessages.personalDataPhone || !reservation.personalData.phone){
            return INVALID_PHONE_ERROR
        }
        if (errorMessages.personalDataMail || !reservation.personalData.mail){
            return INVALID_MAIL_ERROR
        }
        if (errorMessages.personalDataPlate){
            return INVALID_PLATE_ERROR
        }
        const guestsValues = Object.values(errorMessages.guests)
        const guestError = guestsValues.indexOf(true)
        if (guestError !== -1){
            return `El nombre del invitado ${guestError + 1} no es válido`
        }
        return false
    }

    handleClickUpdate(){
        const {
            reservation, reservationId, initialGuestsFound, initialSelectedTime,
            initialPlate, events, selectedEventId, errorMessages, parkings
        } = this.state
        const {getReservationErrors, reserveParking} = this

        if (getReservationErrors()){
            this.setState({
                updateState: FAILED_STATE
            })
            return
        }
        // Check if we have space for all guests
        const guestsFound = reservation.guests.filter(
            el => {return el.name.length > 0}
        )
        const totalGuestsReservation = guestsFound.length + 1
        const currentAvailableSpace = getAvailableSpace(
                events[selectedEventId], reservation.selectedTime)
        if (reservation.selectedTime !== initialSelectedTime &&
            currentAvailableSpace < totalGuestsReservation){
            // if time selected change, there must be room for all guests
            errorMessages.notAvailableSpace = true
            this.setState({
                errorMessages: errorMessages,
                updateState: FAILED_STATE
            })
            return
        } else if (reservation.selectedTime === initialSelectedTime &&
            totalGuestsReservation > initialGuestsFound){
            const additionalGuests = totalGuestsReservation - initialGuestsFound
            if (additionalGuests > currentAvailableSpace){
                errorMessages.notAvailableSpace = true
                this.setState({
                    errorMessages: errorMessages,
                    updateState: FAILED_STATE
                })
                return
            }
        }
        // We have room for everyone, now update space
        const eventDB = (
            `/events/${selectedEventId}/availableHours/${reservation.selectedTime}`
        )
        var currentOcupation = getCurrentOccupation(
                events[selectedEventId], reservation.selectedTime
        )

        if (initialSelectedTime !== reservation.selectedTime){
            // We have to free space on initialSelectedTime
            const initialCurrentOcupation = getCurrentOccupation(
                events[selectedEventId], initialSelectedTime)
            const eventInitialDB = `/events/${selectedEventId}/availableHours/${initialSelectedTime}`
            Firebase.database().ref(eventInitialDB).set(initialCurrentOcupation - initialGuestsFound)

            // Now add guests found in new selected time
            Firebase.database().ref(eventDB).set(currentOcupation + totalGuestsReservation)
        } else if (totalGuestsReservation !== initialGuestsFound){
            // We just have to update current occupation
            if (totalGuestsReservation > initialGuestsFound){
                currentOcupation += totalGuestsReservation - initialGuestsFound
            } else{
                currentOcupation -= initialGuestsFound - totalGuestsReservation
            }
            Firebase.database().ref(eventDB).set(currentOcupation)
        }
        // Now update reservation data
        const dbUrl = `guests/${selectedEventId}/${reservationId}`
        Firebase.database().ref(dbUrl).set(reservation)

        if (reservation.products.length > 0){
            sendProductsUpdateEmail(
                reservationId,
                reservation,
                events[selectedEventId].name
            )
        }

        if (
            !(initialSelectedTime === reservation.selectedTime &&
            initialPlate === reservation.personalData.plate)
        ){
            // We need to update plate info, first remove current parking info
            const endTime = initialSelectedTime + 60*60*1000
            for (var parkingId in parkings){
                Firebase.database().ref(
                    `/reservedParkings/${parkingId}/${endTime}/${selectedEventId}/${reservationId}`
                ).remove()
            }
            // Create new parking info
            if (reservation.personalData.plate.length > 0){
                reserveParking(
                    reservation.personalData.plate,
                    reservation.selectedTime,
                    reservation.selectedTime + 60*60*1000,
                    reservationId
                )
            }
        }

        this.setState({
            updateState: COMPLETED_STATE
        })
    }

    reserveParking(plate, startTime, endTime, resId){
        const {parkings} = this.state
        const {checkForParkingSpace} = this
        const parkingPriorities = Object.keys(parkings).map(parkingId => {
            return parkings[parkingId].priority
        })
        parkingPriorities.sort()
        const orderedParkingsIds = []
        for (var i in parkingPriorities){
            for (var parkingId in parkings){
                if (parkings[parkingId].priority === parkingPriorities[i]){
                    orderedParkingsIds.push(parkingId)
                }
            }
        }
        // Now iterate over ordered parkings by priority and try to find space
        checkForParkingSpace(orderedParkingsIds, 0, plate, startTime, endTime, resId)
    }

    checkForParkingSpace(orderedParkingsIds, index, plate, startTime, endTime, resId){
        const {parkings, selectedEventId} = this.state
        const {checkForParkingSpace} = this
        if (index >= orderedParkingsIds.length){
            this.setState({
                parkingReservationState: `**No fue posible reservar espacio para el vehículo`
            })
            return
        }
        const parkingId = orderedParkingsIds[index]
        const reservedParkingsRef = Firebase.database().ref('/reservedParkings')
        reservedParkingsRef.child(parkingId).orderByKey().startAt(
            startTime.toString()).once('value', snapshot => {
                var reservedParkings = snapshot.val()
                if (reservedParkings == null){
                    reservedParkings = {}
                }
                var currentParkingId = snapshot.ref.key;
                const currentOccupation = parkings[currentParkingId].currentOccupation
                const filteredParkings = filterParkings(reservedParkings, startTime, endTime)
                sumReservedAndCurrentParkings(filteredParkings, currentOccupation, endTime)
                const parkingCapacity = parkings[currentParkingId].capacity
                if (filteredParkings.length < parkingCapacity){
                    // We have space in here
                    reservedParkingsRef.child(
                        `${currentParkingId}/${endTime}/${selectedEventId}/${resId}`
                    ).set({
                        'plate': plate,
                        'start': startTime
                    })
                    const parkingName = parkings[currentParkingId].name
                    this.setState({
                        parkingReservationState: `Se reservó un espacio para el vehículo en ${parkingName}`
                    })
                    return
                }
                return checkForParkingSpace(orderedParkingsIds, index + 1, plate, startTime, endTime, resId)
            })
    }

    handleClickDelete(){
        const {
            selectedEventId, initialGuestsFound, initialSelectedTime,
            initialPlate, reservationId, events, parkings
        } = this.state

        // Update available space
        const currentOccupation = getCurrentOccupation(
            events[selectedEventId], initialSelectedTime
        )
        const eventDB = `/events/${selectedEventId}/availableHours/${initialSelectedTime}`
        const reservationDB = `/guests/${selectedEventId}/${reservationId}`
        Firebase.database().ref(eventDB).set(currentOccupation - initialGuestsFound)
        // Remove reservation
        Firebase.database().ref(reservationDB).remove()
        // Check for parking
        if (initialPlate.length > 0){
            // Since we don't know where the plate is, just try to delete in all parkings
            const endTime = initialSelectedTime + 60*60*1000
            for (var parkingId in parkings){
                Firebase.database().ref(
                    `/reservedParkings/${parkingId}/${endTime}/${selectedEventId}/${reservationId}`
                ).remove()
            }
        }
        this.setState({
            updateState: DELETED_STATE
        })
    }

    handleEventChange(event){
        const eventId = event.target.value
        const cleanErrorMessages = {
            personalDataName: false,
            personalDataPhone: false,
            personalDataMail: false,
            personalDataPlate: false,
            guests: [false, false],
            notAvailableSpace: false,
            selectedEventIdNotFound: false
        }
        this.setState({
            selectedEventId: eventId === CHOOSE_AN_OPTION_TEXT ? null : eventId,
            updateState: NOT_CHOOSEN_STATE,
            errorMessages: cleanErrorMessages
        })
    }

    handleTimeChange(event){
        const {reservation, errorMessages} = this.state
        const timeSelected = event.target.value
        reservation.selectedTime = Number(timeSelected)
        errorMessages.notAvailableSpace = false
        this.setState({
            errorMessages: errorMessages,
            reservation: reservation
        })
    }

    handleProductSelected(productName, productValue){
        const {reservation} = this.state
        const productIsSelected = reservation.products.map(
            el => {return el.name}
        ).includes(productName)

        if (productIsSelected){
            // Remove product
            for (var index in reservation.products){
                if (reservation.products[index].name === productName){
                    break
                }
            }
            reservation.products.splice(index, 1)
        } else{
            reservation.products.push({name: productName, value: productValue})
        }
        this.setState({
            reservation: reservation
        })
    }

    handleWheelChairChange(event){
        const {reservation} = this.state
        reservation.wheelChair = !reservation.wheelChair
        this.setState({
            reservation: reservation
        })
    }

    handleMailInfoChange(event){
        const {reservation} = this.state
        reservation.mailInfo = !reservation.mailInfo
        this.setState({
            reservation: reservation
        })
    }

    componentDidMount(){
        // Get all events that has end timestamp now or in the future
        let ref = Firebase.database().ref('/events')

        ref.orderByChild('end').startAt(new Date().getTime()).on('value', snapshot => {
            var eventsRaw = snapshot.val()
            if (eventsRaw === null){
                eventsRaw = {}
            }
            const availableEvents = parseEvents(eventsRaw, false)
            this.setState({
                events: availableEvents
            })
        })
    }

    render() {
        const {
            selectedEventId,
            updateState,
            errorMessages,
            reservationId,
            events,
            reservation,
            parkingReservationState
        } = this.state
        const {
            handleInputChange,
            handleEventChange,
            handlePersonalDataChange,
            handleTimeChange,
            handleProductSelected,
            getReservationErrors,
            handleWheelChairChange,
            handleReservationChange,
            handleClickUpdate,
            handleClickSearch,
            handleClickDelete,
            handleMailInfoChange
        } = this
        const availableSpace = reservation.selectedTime ? getAvailableSpace(
            events[selectedEventId], reservation.selectedTime
        ) : 0
        const unableReservation = updateState === COMPLETED_STATE ||
                                     updateState === DELETED_STATE
        return (
            <div className="registerForm">
                <div className="register-form-header-container">
                    <div className="guests-block">
                        <div className="personal-data-block">
                            <CustomEventPicker
                                events={events}
                                selectedEventId={selectedEventId}
                                onEventSelected={handleEventChange}
                                disabled={updateState !== NOT_CHOOSEN_STATE}
                            />
                        </div>
                        <div className="personal-data-block horizontal-space-block">
                            <ReservationIdInput
                                reservationId={reservationId}
                                onReservationChange={handleReservationChange}
                                onSearchClick={handleClickSearch}
                                errorMessages={errorMessages}
                                disabled={updateState !== NOT_CHOOSEN_STATE}
                            />
                        </div>
                    </div>
                    {
                        reservation.selectedTime ?
                        <div>
                            <EventDetailsDisplay
                                events={events}
                                selectedEventId={selectedEventId}
                            />
                        </div> : <div> </div>
                    }
                </div>
                <div className="shadow-box"></div>
                {
                    ![
                        PENDING_STATE, FAILED_STATE, COMPLETED_STATE, DELETED_STATE
                    ].includes(updateState) ?
                    <div className="empty-div-fixed-height"></div> :
                    <div className="div-align-block">
                        <div className="container-event-details">
                            <div className="time-selection-block inline-element">
                                <CustomTimePicker
                                    availableHours={events[selectedEventId].availableHours}
                                    showWarning={true}
                                    selectedTime={reservation.selectedTime}
                                    availableSpace={availableSpace}
                                    onTimeSelected={handleTimeChange}
                                    disabled={unableReservation}
                                />
                            </div>
                            <div className="product-selection-block inline-element">
                                <CustomProductPicker
                                    productsSelected={reservation.products}
                                    onProductSelected={handleProductSelected}
                                />
                            </div>
                        </div>
                        <div className="div-align-block">
                            <GuestsInputForm
                                personalData={reservation.personalData}
                                guests={reservation.guests}
                                errorMessages={errorMessages}
                                disabled={unableReservation}
                                handlePersonalDataChange={handlePersonalDataChange}
                                handleGuestInputChange={handleInputChange}
                            />
                        </div>
                        <div>
                            <WheelChairPicker
                                wheelChairRequired={reservation.wheelChair}
                                onChange={handleWheelChairChange}
                                disabled={unableReservation}
                            />
                        </div>
                        <div>
                            <MailInfoPicker
                                mailInfoData={reservation.mailInfo}
                                onChange={handleMailInfoChange}
                                disabled={unableReservation}
                            />
                        </div>
                        <div className="guests-block">
                            <div className="inline-element horizontal-block">
                                <input
                                    className="button-add-reserve"
                                    type="button"
                                    value={UPDATE_BUTTON}
                                    disabled={unableReservation}
                                    onClick={handleClickUpdate}/>
                            </div>
                            <div className="inline-element horizontal-block">
                                <input
                                className="button-warning"
                                type="button"
                                value={DELETE_RESERVATION_BUTTON}
                                disabled={unableReservation}
                                onClick={handleClickDelete}
                            />
                            </div>
                        </div>
                        <div>
                            <ReservationResult
                                reservationState={updateState}
                                reservationId={reservationId}
                                reservationProducts={reservation.products}
                                parkingReservationState={parkingReservationState}
                                errorMessages={getReservationErrors()}
                                isUpdate={true}
                            />
                        </div>
                        <div className="sanitary-measures-reminder-text">
                            <div className="sanitary-measures-title">Por la salud de todos</div>
                            <div>{SANITARY_MEASURES_TEXT}</div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default EditReservationForm
